import { Record as record } from 'immutable';
import { construct, fields } from '../../../src/helpers/LinkMapper';
import { getDefaults, getResolvers } from '../../../src/helpers/Records';

const schema = {
    id: [ fields.string ],
    group: [ fields.string ],
    ticketNumber: [ fields.bool ],
    photocardNumber: [ fields.bool ],
    smartcardNumber: [ fields.bool ],
    contactlessNumber: [ fields.bool ],
    ticketUpload: [ fields.bool ],
    statementUpload: [ fields.bool ],
    allowPreviousUpload: [ fields.bool ]
};

export default class DelayRepayTicketType extends record(getDefaults(schema)) {
    static fromJSON (json = {}) {
        return construct(DelayRepayTicketType, json, getResolvers(schema));
    }
}
